export default class {
    constructor(attributes) {
        Object.assign(this, attributes);
    }
}
